import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgUnfollow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 27,
	viewBox: "0 0 28 27",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		filter: "url(#filter0_d)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M13.9999 5.83333C16.2999 5.83333 18.1666 7.7 18.1666 10C18.1666 10.5417 18.0583 11.05 17.8666 11.525L20.2999 13.9583C21.5583 12.9083 22.5499 11.55 23.1583 10C21.7166 6.34167 18.1583 3.75 13.9916 3.75C12.8249 3.75 11.7083 3.95833 10.6749 4.33333L12.4749 6.13333C12.9499 5.94167 13.4583 5.83333 13.9999 5.83333ZM5.66659 3.55833L7.56659 5.45833L7.94992 5.84167C6.56659 6.91667 5.48325 8.35 4.83325 10C6.27492 13.6583 9.83325 16.25 13.9999 16.25C15.2916 16.25 16.5249 16 17.6499 15.55L17.9999 15.9L20.4416 18.3333L21.4999 17.275L6.72492 2.5L5.66659 3.55833ZM10.2749 8.16667L11.5666 9.45833C11.5249 9.63334 11.4999 9.81667 11.4999 10C11.4999 11.3833 12.6166 12.5 13.9999 12.5C14.1833 12.5 14.3666 12.475 14.5416 12.4333L15.8333 13.725C15.2749 14 14.6583 14.1667 13.9999 14.1667C11.6999 14.1667 9.83325 12.3 9.83325 10C9.83325 9.34167 9.99992 8.725 10.2749 8.16667ZM13.8666 7.51667L16.4916 10.1417L16.5083 10.0083C16.5083 8.625 15.3916 7.50833 14.0083 7.50833L13.8666 7.51667Z",
			fill: "inherit"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d",
		x: 0,
		y: 0,
		width: 28,
		height: 28,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow",
				result: "shape"
			})
		]
	}) })]
});
export default SvgUnfollow;
